var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c(
        "div",
        {
          ref: "overlay",
          staticClass: "mfa-overlay",
          attrs: {
            id: _vm.id,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.id + "-title",
            "aria-describedby": _vm.id + "-description",
          },
        },
        [
          _c("div", { staticClass: "mfa-backdrop" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mfa-dialog" },
            [
              _c("div", { staticClass: "mfa-header" }, [
                _c("div", { staticClass: "mfa-header-container" }, [
                  _vm.canGoBack
                    ? _c(
                        "button",
                        {
                          staticClass: "mfa-header-btn mfa-header-back",
                          attrs: { "aria-label": "Back" },
                          on: { click: _vm.goBack },
                        },
                        [_c("i", { staticClass: "fa-regular fa-angle-left" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "h2",
                    {
                      staticClass: "mfa-title",
                      attrs: { id: _vm.id + "-title" },
                    },
                    [_vm._v(_vm._s(_vm.headerTitle))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "mfa-close",
                    attrs: { type: "button", "aria-label": "Close dialog" },
                    on: { click: _vm.close },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M2 2l12 12M14 2L2 14",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "transition",
                {
                  attrs: { name: "mfa-view", mode: "out-in", appear: "" },
                  on: {
                    "after-enter": _vm.afterEntered,
                    "after-appear": _vm.afterEntered,
                  },
                },
                [
                  _vm.currentView === "code"
                    ? _c("div", { staticClass: "mfa-body" }, [
                        _c(
                          "p",
                          {
                            staticClass: "mfa-description",
                            attrs: { id: _vm.id + "-description" },
                          },
                          [_vm._v(_vm._s(_vm.description))]
                        ),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            staticClass: "mfa-form",
                            attrs: { novalidate: "" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.submit.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "mfa-field" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "mfa-label",
                                  attrs: { for: _vm.id + "-input" },
                                },
                                [_vm._v("Verification code")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.code,
                                    expression: "code",
                                  },
                                ],
                                ref: "codeInput",
                                staticClass: "mfa-input",
                                class: { "is-error": _vm.hasError },
                                attrs: {
                                  type: "text",
                                  inputmode: "text",
                                  pattern: "[A-Z0-9]",
                                  maxlength: _vm.codeLength,
                                  autocomplete: "off",
                                  "aria-label": "Code input",
                                  id: _vm.id + "-input",
                                },
                                domProps: { value: _vm.code },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.code = $event.target.value
                                    },
                                    function ($event) {
                                      return _vm.onInput()
                                    },
                                  ],
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "transition",
                              { attrs: { name: "mfa-error-fade" } },
                              [
                                _vm.errorMessage
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "mfa-error",
                                        attrs: { role: "alert" },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-regular fa-circle-exclamation",
                                        }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.errorMessage) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.expiryText
                              ? _c("p", { staticClass: "mfa-description" }, [
                                  _vm._v(_vm._s(_vm.expiryText)),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm.currentView === "method-picker"
                    ? _c(
                        "div",
                        { key: "picker", staticClass: "mfa-body" },
                        [
                          _vm.isSetup
                            ? _c(
                                "p",
                                { staticClass: "mfa-subtext mfa-body-text" },
                                [
                                  _vm._v(
                                    "\n          Your account admin is requiring two-factor authentication (2FA) on your account"
                                  ),
                                  _vm.graceDays > 1
                                    ? [
                                        _vm._v(
                                          ", you have " +
                                            _vm._s(_vm.graceDays) +
                                            " days remaining"
                                        ),
                                      ]
                                    : _vm.graceDays === 1
                                    ? [_vm._v(", you have 1 day remaining")]
                                    : _vm._e(),
                                  _vm._v(
                                    ". Please sign up using one of the methods below.\n          "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "mfa-body-link",
                                      attrs: {
                                        target: "_blank",
                                        href: "https://blogs.gadzoom.net/2026/06/15/2fa-login-methods/",
                                      },
                                    },
                                    [_vm._v("Learn more here.")]
                                  ),
                                ],
                                2
                              )
                            : _c(
                                "p",
                                { staticClass: "mfa-subtext mfa-body-text" },
                                [
                                  _vm._v(
                                    "Select a verification method and we'll send a code."
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mfa-method-list" },
                            _vm._l(_vm.selectableMethods, function (opt) {
                              return _c(
                                "button",
                                {
                                  key: opt.method,
                                  staticClass: "mfa-method-item",
                                  class: {
                                    "is-current":
                                      opt.method === _vm.challengeMethod,
                                    "is-loading":
                                      _vm.resendLoading &&
                                      _vm.pendingMethod === opt.method,
                                  },
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.resendLoading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectMethod(opt)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "mfa-method-icon-wrap" },
                                    [
                                      opt.method === "TOTP"
                                        ? _c("i", {
                                            staticClass:
                                              "fa-regular fa-mobile-notch",
                                          })
                                        : opt.method === "SMS"
                                        ? _c("i", {
                                            staticClass:
                                              "fa-regular fa-comment",
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "fa-regular fa-envelope",
                                          }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "mfa-method-info" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mfa-method-name" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.methodLabel(opt.method))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isSetup
                                        ? [
                                            opt.method === "SMS"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mfa-method-dest",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Use your phone number for two-factor authentication. Enter the code sent via SMS."
                                                    ),
                                                  ]
                                                )
                                              : opt.method === "EMAIL"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mfa-method-dest",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Use your email for two-factor authentication. Enter the code sent to your account's email."
                                                    ),
                                                  ]
                                                )
                                              : opt.method === "TOTP"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mfa-method-dest",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Use your authenticator app for authentication. Enter the code it provides when prompted."
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : [
                                            opt.challengeDestination
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mfa-method-dest",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        opt.challengeDestination
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  !_vm.isSetup
                                    ? _c(
                                        "span",
                                        { staticClass: "mfa-method-security" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.methodSecurityLabel(
                                                  opt.method
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _vm.resendLoading &&
                                          _vm.pendingMethod === opt.method
                                            ? _c("span", {
                                                staticClass: "mfa-spinner",
                                              })
                                            : opt.method === _vm.challengeMethod
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-regular fa-check",
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "mfa-error-fade" } },
                            [
                              _vm.errorMessage
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mfa-error",
                                      attrs: { role: "alert" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-exclamation",
                                      }),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.errorMessage) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isSetup
                            ? _c(
                                "button",
                                {
                                  staticClass: "mfa-link mfa-backup-link",
                                  attrs: { type: "button" },
                                  on: { click: _vm.openBackupCode },
                                },
                                [
                                  _vm._v(
                                    "\n          Use a backup code\n        "
                                  ),
                                ]
                              )
                            : _vm.graceDays && _vm.graceDays > 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "mfa-link mfa-backup-link",
                                  attrs: { type: "button" },
                                  on: { click: _vm.emitConfirmed },
                                },
                                [_vm._v("\n          Skip\n        ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm.currentView === "backup-code"
                    ? _c(
                        "div",
                        { key: "backup-code", staticClass: "mfa-body" },
                        [
                          _c(
                            "span",
                            { staticClass: "mfa-subtext mfa-body-text" },
                            [
                              _vm._v(
                                "\n          Enter one of your single-use backup codes\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mfa-field" }, [
                            _c(
                              "label",
                              {
                                staticClass: "mfa-label",
                                attrs: { for: "mfa-backup-code" },
                              },
                              [_vm._v("Backup Code")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.backupCode,
                                  expression: "backupCode",
                                },
                              ],
                              ref: "backupInput",
                              staticClass: "mfa-input",
                              attrs: {
                                id: "mfa-backup-code",
                                type: "text",
                                autocomplete: "off",
                                spellcheck: "false",
                              },
                              domProps: { value: _vm.backupCode },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.backupCode = $event.target.value
                                  },
                                  function ($event) {
                                    return _vm.onInput()
                                  },
                                ],
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.submit.apply(null, arguments)
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "mfa-error-fade" } },
                            [
                              _vm.errorMessage
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mfa-error",
                                      attrs: { role: "alert" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-exclamation",
                                      }),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.errorMessage) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm.currentView === "backup-list"
                    ? _c(
                        "div",
                        { key: "backup-list", staticClass: "mfa-body" },
                        [
                          _c("h3", { staticClass: "mfa-heading" }, [
                            _vm._v("Save your backup codes"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "mfa-subtext" }, [
                            _vm._v(
                              "\n              Each code can only be used once if you lose access to your two-factor authentication method. Make sure to copy and save them in a safe place.\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "codes-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "mfa-backup-list" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "copy-btn",
                                    on: { click: _vm.copyCodes },
                                  },
                                  [
                                    _c(
                                      "transition",
                                      { attrs: { name: "tooltip" } },
                                      [
                                        _vm.showCopied
                                          ? _c(
                                              "span",
                                              { staticClass: "copy-tooltip" },
                                              [_vm._v("Copied!")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa-regular fa-copy",
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.backupList, function (code) {
                                  return _c("span", { key: code }, [
                                    _vm._v(_vm._s(code)),
                                  ])
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "mfa-link mfa-diff-method-link",
                              attrs: {
                                type: "button",
                                disabled: _vm.downloading,
                              },
                              on: { click: _vm.downloadCodes },
                            },
                            [_vm._v("\n          Download\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "mfa-error-fade" } },
                            [
                              _vm.errorMessage
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mfa-error",
                                      attrs: { role: "alert" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-exclamation",
                                      }),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.errorMessage) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm.currentView === "edit-method"
                    ? _c(
                        "div",
                        { key: "edit-method", staticClass: "mfa-body" },
                        [
                          _c("div", { staticClass: "mfa-field" }, [
                            _c(
                              "label",
                              {
                                staticClass: "mfa-label",
                                attrs: { for: "mfa-activate-destination" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.methodLabel(_vm.challengeMethod)) +
                                    " for Verification"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.challengeMethod === "SMS"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ui-library redesigned fullscreen",
                                  },
                                  [
                                    _c("vue-tel-input", {
                                      ref: "activateDestination",
                                      attrs: {
                                        id: "mfa-activate-destination",
                                        inputOptions: _vm.telInputOptions,
                                      },
                                      model: {
                                        value: _vm.editDestination,
                                        callback: function ($$v) {
                                          _vm.editDestination = $$v
                                        },
                                        expression: "editDestination",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.editDestination,
                                      expression: "editDestination",
                                    },
                                  ],
                                  ref: "activateDestination",
                                  staticClass: "mfa-input",
                                  attrs: {
                                    id: "mfa-activate-destination",
                                    type: "text",
                                    placeholder: _vm.editPlaceholder,
                                    autocomplete: "off",
                                    spellcheck: "false",
                                  },
                                  domProps: { value: _vm.editDestination },
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.submit.apply(null, arguments)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.editDestination = $event.target.value
                                    },
                                  },
                                }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "mfa-error-fade" } },
                            [
                              _vm.errorMessage
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mfa-error",
                                      attrs: { role: "alert" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-exclamation",
                                      }),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.errorMessage) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm.currentView === "activate-method"
                    ? _c(
                        "div",
                        { key: "activate-method", staticClass: "mfa-body" },
                        [
                          _c(
                            "span",
                            { staticClass: "mfa-activate-body" },
                            [
                              _vm.challengeMethod === "SMS"
                                ? [
                                    _c("i", {
                                      staticClass: "fa-regular fa-comment",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n              A text message with your code has been sent to " +
                                          _vm._s(
                                            _vm.editDestination.length > 0
                                              ? _vm.editDestination
                                              : _vm.editPlaceholder
                                          ) +
                                          "\n            "
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("i", {
                                      staticClass: "fa-regular fa-envelope",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n              An email with your code has been sent to " +
                                          _vm._s(
                                            _vm.editDestination.length > 0
                                              ? _vm.editDestination
                                              : _vm.editPlaceholder
                                          ) +
                                          "\n            "
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mfa-field" }, [
                            _c(
                              "label",
                              {
                                staticClass: "mfa-label",
                                attrs: { for: "mfa-activate-code" },
                              },
                              [_vm._v("Enter Code")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.code,
                                  expression: "code",
                                },
                              ],
                              ref: "activateCodeInput",
                              staticClass: "mfa-input",
                              attrs: {
                                id: "mfa-activate-code",
                                type: "text",
                                autocomplete: "off",
                                spellcheck: "false",
                              },
                              domProps: { value: _vm.code },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.submit.apply(null, arguments)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.code = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "mfa-error-fade" } },
                            [
                              _vm.errorMessage
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mfa-error",
                                      attrs: { role: "alert" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-exclamation",
                                      }),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.errorMessage) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm.currentView === "activate-totp"
                    ? _c(
                        "div",
                        { key: "activate-totp", staticClass: "mfa-body" },
                        [
                          _c("div", { staticClass: "mfa-activate-body" }, [
                            _c("div", { staticClass: "step-number" }, [
                              _vm._v("1"),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  "\n              Download TOTP on your phone\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US",
                                  },
                                },
                                [_vm._v("Download on Google Play")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: "https://apps.apple.com/us/app/microsoft-authenticator/id983156458",
                                  },
                                },
                                [_vm._v("Download on the iOS App Store")]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mfa-activate-body" }, [
                            _c("div", { staticClass: "step-number" }, [
                              _vm._v("2"),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n            Open the app and scan this QR code or enter the key\n            "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _vm.generating
                                ? _c("span", { staticClass: "is-loading" }, [
                                    _vm._v("Loading…"),
                                  ])
                                : _c("span", { staticClass: "mfa-subtext" }, [
                                    _vm._v(_vm._s(_vm.totpSecretKey)),
                                  ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mfa-qr-image" }, [
                            _vm.generating
                              ? _c("div", { staticClass: "qr-skeleton" })
                              : !_vm.totpQrUrl
                              ? _c("div", { staticClass: "qr-error" }, [
                                  _c("i", {
                                    staticClass: "fa-regular fa-rotate-right",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "mfa-link",
                                      on: { click: _vm.launchTotp },
                                    },
                                    [_vm._v("Retry")]
                                  ),
                                ])
                              : _c("img", {
                                  attrs: {
                                    src:
                                      "data:image/png;base64," + _vm.totpQrUrl,
                                    alt: "QR Code",
                                  },
                                }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mfa-activate-body" }, [
                            _c("div", { staticClass: "step-number" }, [
                              _vm._v("3"),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  "Enter the verification code from the app on this page"
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mfa-field" }, [
                            _c(
                              "label",
                              {
                                staticClass: "mfa-label",
                                attrs: { for: "mfa-activate-code" },
                              },
                              [_vm._v("Enter Code")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.code,
                                  expression: "code",
                                },
                              ],
                              ref: "activateCodeInput",
                              staticClass: "mfa-input",
                              attrs: {
                                id: "mfa-activate-code",
                                type: "text",
                                autocomplete: "off",
                                spellcheck: "false",
                              },
                              domProps: { value: _vm.code },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.submit.apply(null, arguments)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.code = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "mfa-error-fade" } },
                            [
                              _vm.errorMessage
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mfa-error",
                                      attrs: { role: "alert" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-exclamation",
                                      }),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.errorMessage) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.currentView !== "method-picker"
                ? _c("div", { staticClass: "mfa-footer" }, [
                    _vm.showBackupCodeButton
                      ? _c(
                          "button",
                          {
                            staticClass: "mfa-link mfa-footer-backup-link",
                            attrs: { type: "button" },
                            on: { click: _vm.openBackupCode },
                          },
                          [_vm._v("\n        Use Backup Code\n      ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showResend
                      ? _c(
                          "button",
                          {
                            staticClass: "mfa-btn mfa-btn--resend",
                            class: { "is-loading": _vm.resendLoading },
                            attrs: {
                              type: "button",
                              disabled: _vm.resendLoading || _vm.resendBlocked,
                            },
                            on: { click: _vm.resendCode },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.resendBlocked
                                    ? "Resend Code (" +
                                        _vm.resendCountdown +
                                        "s)"
                                    : "Resend Code"
                                ) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "mfa-btn mfa-btn--primary",
                        class: { "is-loading": _vm.isLoading },
                        attrs: {
                          type: "button",
                          disabled: _vm.isLoading || !_vm.canSubmit,
                          title: _vm.submitTitle,
                        },
                        on: { click: _vm.submit },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.submitText) + "\n      "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }